const state = {};

const actions = {
  async reportListInit({ rootState, commit, state }, data) {
    let res = await rootState.axios.get(rootState.api.appReportList, {
      params: data,
    });

    return res;
  },
  async appReportAnDetail({ rootState, commit, state }, data) {
    let res = await rootState.axios.get(rootState.api.appReportAnDetail, {
      params: data,
    });

    return res;
  },
};

const mutations = {};

const getters = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
